<template>
    <a
        href="#"
        class="WLink"
        :class="[iconPlacement, color]"
        :disabled="disabled"
        @click.prevent="disabled ? undefined : $emit('click', $event)"
    >
        <WIcon
            v-if="icon"
            :icon="icon"
            :size="14"
            :class="iconPlacement"
        />
        <slot />
    </a>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'WLink',
    props: {
        icon: VueTypes.string,
        iconPlacement: VueTypes.oneOf(['left', 'right']).def('right'),
        disabled: VueTypes.bool.def(false),
        color: VueTypes.oneOf(['primary', 'accent-blue']).def('accent-blue'),
    },
}
</script>

<style scoped lang="scss">
.WLink {
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    color: $accent-blue;
	font-size: 14px;
	font-family: $font-family-sans-serif;
	font-weight: $font-weight-semibold;
    transition: all .3s ease;
	cursor: pointer;
	.WIcon {
		color: $body-color;
	}
	&.right {
		.WIcon {
			margin-right: 5px;
		}
	}
	&.left {
		flex-direction: row-reverse;
		.WIcon {
			margin-left: 5px;
		}
	}
	&[disabled] {
		color: $gray-medium;
		cursor: not-allowed;
		.WIcon {
			color: $gray-medium;
		}
    }
	&:hover:not([disabled]) {
		color: $secondary;
		.WIcon {
			color: $secondary;
		}
	}

	&.accent-blue {
		color: $accent-blue;
		&:hover:not([disabled]) {
			color: darken($accent-blue, 10%);
		}
	}

}

</style>
